import Lower from "./Lower";
import { useState, useEffect } from "react";
import NewsBox from "./NewsBox";
import Slider from "react-slick";
function App() {
  const [data, setData] = useState([
    {
      title:
        "ASUS ROG Zephyrus G14 (2024) gaming laptop launched in India: Check details",
      description:
        "The ASUS ROG Zephyrus G14, powered by AMD Ryzen 9 8945HS processor, is offered with up to NVIDIA GeForce RTX 4060 graphic processing unit (GPU)",
      content:
        "ASUS has launched in India the ROG Zephyrus G14. The gaming laptop from Taiwanese PC maker is powered by AMD Ryzen 9 8945HS processor, which features a dedicated Neural Processing Unit (NPU) for handling artificial intelligence workloads. Additionall... [1400 chars]",
      url: "https://www.business-standard.com/technology/gadgets/asus-rog-zephyrus-g14-2024-gaming-laptop-launched-in-india-check-details-124062000331_1.html",
      image:
        "https://bsmedia.business-standard.com/_media/bs/img/article/2024-06/20/thumb/featurecrop/400X400/1718865557-5971.jpg",
      publishedAt: "2024-06-20T06:44:32Z",
      source: {
        name: "Business Standard",
        url: "https://www.business-standard.com",
      },
    },
    {
      title:
        "Police arrest two men after 'disturbance' outside busy train station",
      description:
        "Officers descended on the scene outside Wigan Wallgate on Tuesday",
      content:
        "We have more newsletters\nThank you for subscribing!\nSomething went wrong, please try again later.\nInvalid email Something went wrong, please try again later.\nSign up for the MyWigan newsletter for the biggest stories direct to your inbox\nWe have more... [1046 chars]",
      url: "https://www.manchestereveningnews.co.uk/news/greater-manchester-news/police-arrest-two-men-after-29387148",
      image:
        "https://i2-prod.manchestereveningnews.co.uk/incoming/article29116295.ece/ALTERNATES/s1200/1_WIGAN-GENERIC-GV-25th-January-2021.jpg",
      publishedAt: "2024-06-20T06:18:00Z",
      source: {
        name: "Manchester Evening News",
        url: "https://www.manchestereveningnews.co.uk",
      },
    },
    {
      title:
        "AEMO warns of immediate gas shortfall threat as cold snap, renewable lulls and outages bite",
      description:
        "Gas prices return to crisis highs as cold weather, a lack of renewable energy and plant outages smash the east coast market.",
      content:
        "In short: The Australian Energy Market Operator has warned of immediate gas supply risks across south eastern Australian.\nThe Australian Energy Market Operator has warned of immediate gas supply risks across south eastern Australian. The warning come... [4422 chars]",
      url: "https://www.abc.net.au/news/2024-06-20/aemo-warns-of-immediate-gas-shortage-risks-in-se-australia/104003166",
      image:
        "https://live-production.wcms.abc-cdn.net.au/6cf53c5c8ccf7bdc6729598ac7258ad3?impolicy=wcms_watermark_news&cropH=1575&cropW=2800&xPos=0&yPos=0&width=862&height=485&imformat=generic",
      publishedAt: "2024-06-20T06:11:55Z",
      source: {
        name: "ABC News",
        url: "https://www.abc.net.au",
      },
    },
    {
      title: "Bilawal to meet Shehbaz today to discuss budget concerns",
      description:
        "PPP chairman will meet the prime minister at 4pm at Prime Minister’s House",
      content:
        "Prime Minister Shehbaz Sharif is set to meet with Pakistan People's Party (PPP) Chairman Bilawal Bhutto-Zardari after tensions within the ruling coalition have heightened over the federal budget for the fiscal year 2024-25, according to sources.\nThe ... [1204 chars]",
      url: "https://tribune.com.pk/story/2472546/bilawal-to-meet-shehbaz-today-to-discuss-budget-concerns",
      image:
        "https://i.tribune.com.pk/media/images/dfgsr1718861998-0/dfgsr1718861998-0.jpg",
      publishedAt: "2024-06-20T06:04:14Z",
      source: {
        name: "The Express Tribune",
        url: "https://tribune.com.pk",
      },
    },
    {
      title:
        "Louisiana verplicht scholen om tien geboden in lokalen op te hangen",
      description:
        "De Bijbelse leefregels moeten duidelijk leesbaar te vinden zijn in alle openbare klassen, van peuterschool tot universiteit.",
      content:
        "AFP De tien geboden\nNOS Nieuws • vandaag, 08:03 Louisiana verplicht scholen om tien geboden in lokalen op te hangen\nDe Amerikaanse staat Louisiana heeft een wet aangenomen die scholen verplicht om de tien geboden op te hangen in alle klaslokalen. De ... [1656 chars]",
      url: "https://nos.nl/artikel/2525346-louisiana-verplicht-scholen-om-tien-geboden-in-lokalen-op-te-hangen",
      image: "https://cdn.nos.nl/image/2024/06/20/1097463/1024x576a.jpg",
      publishedAt: "2024-06-20T06:03:24Z",
      source: {
        name: "NOS",
        url: "https://nos.nl",
      },
    },
    {
      title: "Anklager eksen for mishandling",
      description: "Nye detaljer er hentet frem i rettsdokumenter.",
      content:
        "Tidligere i juni kom nyheten om at Billy Ray Cyrus (62), Miley Cyrus' far, har søkt om skilsmissse fra kona Firerose (36), hvis egentlige navn er Johanna Rosie Hodges . Artistkollegaenes ekteskap ble av det kortvarige slaget, og da Cyrus søkte om ski... [3288 chars]",
      url: "https://www.seher.no/kjendis/anklager-eksen-for-mishandling/81568231",
      image:
        "https://www.seher.no/images/81569019.jpg?imageId=81569019&panow=100&panoh=100&panox=0&panoy=0&heightw=43.90243902439&heighth=60.493827160494&heightx=8.2926829268293&heighty=28.80658436214&width=1200&height=630",
      publishedAt: "2024-06-20T06:00:41Z",
      source: {
        name: "Seoghør.no",
        url: "https://www.seher.no",
      },
    },
    {
      title:
        "Maturità 2024, oggi la seconda prova di indirizzo: le news in diretta",
      description:
        "L’autore non veniva selezionato dal 2010 ed era molto atteso dai maturandi. Prova di matematica invece allo Scientifico e terza lingua al liceo linguistico",
      content:
        "Seconda prova: ecco tutte le materie d’esame nei diversi indirizzi\nEcco le prove per tutti gli indirizzi: per il liceo di Scienze umane ci sarà Scienze Umane: Diritto ed Economia politica all'opzione Economico-sociale, al liceo Artistico affronterann... [849 chars]",
      url: "https://www.repubblica.it/cronaca/2024/06/20/diretta/maturita_2024_seconda_prova_oggi-423259774/",
      image:
        "https://www.repstatic.it/content/nazionale/img/2024/06/20/071849160-97cbc366-4101-4ecb-8323-9dfb39a836c3.jpg",
      publishedAt: "2024-06-20T05:57:44Z",
      source: {
        name: "la Repubblica",
        url: "https://www.repubblica.it",
      },
    },
    {
      title:
        "Justin Timberlake: Polizei teilt Foto nach Festnahme wegen Trunkenheit",
      description:
        "Der Sänger ist wegen Trunkenheit am Steuer festgenommen worden. Die zuständige Polizeibehörde gab ein Statement heraus – samt Justin Timberlakes Mugshot.",
      content:
        'Sind Sie ein Gewinnertyp? Jetzt spielen!\n"Augen blutunterlaufen und glasig" Polizei veröffentlicht Foto nach Festnahme von Justin Timberlake Von dpa , jdo Aktualisiert am 20.06.2024 - 07:54 Uhr Lesedauer: 2 Min. Justin Timberlake: Der US-Star wurde f... [1768 chars]',
      url: "https://www.t-online.de/unterhaltung/stars/id_100430196/justin-timberlake-polizei-teilt-foto-nach-festnahme-wegen-trunkenheit.html",
      image:
        "https://images.t-online.de/2024/06/uBI-YCbnRweb/832x148:1715x964/fit-in/1800x0/justin-timberlake-der-us-star-tourt-derzeit-durch-die-usa.jpg",
      publishedAt: "2024-06-20T05:54:00Z",
      source: {
        name: "t-online",
        url: "https://www.t-online.de",
      },
    },
    {
      title:
        "Ash Barty to return to Wimbledon court for exhibition doubles tournament",
      description:
        "Retired Australian tennis great Ash Barty is set to return to the scene of one of her greatest accomplishments when she takes part in an exhibition doubles match at Wimbledon.",
      content:
        "Retired Australian tennis great Ash Barty is set to return to the scene of one of her greatest accomplishments when she takes part in an exhibition doubles match at Wimbledon.\nThe 2021 Wimbledon singles champ hasn't played on the grass courts of Wimb... [1022 chars]",
      url: "https://www.abc.net.au/news/2024-06-20/ash-barty-wimbledon-return-exhibition-doubles/104003090",
      image:
        "https://live-production.wcms.abc-cdn.net.au/3f3b2b29b3d5d6f548631d5a0eb04620?impolicy=wcms_watermark_news&cropH=2813&cropW=5000&xPos=0&yPos=260&width=862&height=485&imformat=generic",
      publishedAt: "2024-06-20T05:51:42Z",
      source: {
        name: "ABC News",
        url: "https://www.abc.net.au",
      },
    },
    {
      title:
        "Hezbollah minaccia Cipro: 'Siamo pronti ad attaccare chi aiuta Israele'",
      description:
        "Christodoulides risponde: 'Siamo parte della soluzione, non del problema' (ANSA)",
      content:
        "Il leader di Hezbollah, Hassan Nasrallah, ha affermato ieri che una guerra che coinvolgesse il Libano avrebbe implicazioni regionali e che il gruppo armato sciita libanese attaccherebbe qualsiasi altro Paese della regione che abbia assistito Israele ... [986 chars]",
      url: "https://www.ansa.it/sito/notizie/mondo/2024/06/20/hezbollah-minaccia-cipro-siamo-pronti-ad-attaccare-chi-aiuta-israele_621d2eff-a19d-4456-a607-30f5bacb16d6.html",
      image:
        "https://www.ansa.it/webimages/img_700/2024/6/19/17185adb326ae2df5a89b7b482625bb3.jpg",
      publishedAt: "2024-06-20T05:47:00Z",
      source: {
        name: "Agenzia ANSA",
        url: "https://www.ansa.it",
      },
    },
  ]);
  const [qy, setQy] = useState("india");
  const fun = (e) => {
    e.preventDefault();
    let gp =
      document.getElementsByClassName("textip")[0] === undefined
        ? "india"
        : document.getElementsByClassName("textip")[0].value;
    // console.log(typeof gp);
    // console.log(gp);
    setQy(gp);
    (async () => {
      const res = await fetch(
        `https://gnews.io/api/v4/top-headlines?q=${qy}&apikey=092449c6d57ac89f6131b6ed6336698d`
      );
      const da = await res.json();
      // console.log(da);
      if (da.articles.length >= 1) {
        setData(da.articles);
      }
      // console.log(data);
    })();
    // console.log(qy);
  };
  const st = (e) => {
    e.preventDefault();
    setQy(e.target.value);
  };

  useEffect(() => {
    // console.log("cal);
    // const i = "india"
    (async () => {
      const res = await fetch(
        `https://gnews.io/api/v4/top-headlines?q=india&apikey=092449c6d57ac89f6131b6ed6336698d`
      );
      const da = await res.json();
      // console.log(da);
      if (da.articles.length >= 1) {
        setData(da.articles);
      }
    })();
  }, []);

  let defa = [
    {
      img: "https://m-cdn.phonearena.com/images/article/142800-wide-two_1200/Googles-Pixel-7-and-7-Pros-design-gets-revealed-even-more-with-fresh-crisp-renders.jpg",
      author: "Un-revealed",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <div className="App bg-primary">
      {/* Navbar */}

      {/* <nav className=" shadow-md fixed w-full bg-black"> */}
      <div className=" bg-secondary container fixed z-10  mx-auto px-4 py-2 flex flex-wrap justify-between items-center">
        <div className="w-full md:w-auto text-center md:text-left">
          <div className="text-2xl font-bold text-write">Dev.news</div>
        </div>
        <div className="w-full md:w-auto md:ml-auto mt-2 md:mt-0">
          <div className="relative">
            <form className="form1" onSubmit={fun}>
              <input
                type="text"
                placeholder="search"
                onChange={st}
                className="textip w-full md:w-64 px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                type="submit"
                className="absolute right-0 top-0 h-full px-4 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700"
              >
                Search
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* </nav> */}

      <div className="content">
        <div className="container pt-[10vh] px-8">
          <Slider {...settings}>
            {data.map((d, index) => (
              <div key={index} className="border-white border-2 rounded-lg">
                <div
                  className="h-[50vh] md:h-screen relative bg-cover bg-center bg-no-repeat shadow-md p-8 md:m-2 rounded-lg  "
                  style={{
                    backgroundImage: `url(${
                      d.image !== null && d.image !== "" ? d.image : defa[0].img
                    })`,
                  }}
                  ind={index}
                >
                  <div className="absolute inset-0 flex items-center justify-center bg-[#020825] bg-opacity-50 md:bg-opacity-50 rounded-lg">
                    <div className="m-5 sm:m-auto sm:text-center text-white space-y-4">
                      <h2 className="text-4xl font-bold">{d.title}</h2>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="flex flex-wrap justify-around mx-4">
          {data.map((news) => (
            <NewsBox
              image={
                news.image !== null && news.image !== ""
                  ? news.image
                  : defa[0].img
              }
              author={
                news.source.name !== null ? news.source.name : defa[0].author
              }
              title={news.title}
              description={news.description}
              story={news.content}
              publishedAt={news.publishedAt}
              url={news.url}
            ></NewsBox>
          ))}
        </div>
        {/* </div> */}
      </div>

      <Lower />
    </div>
  );
}

export default App;
